import useFetch from "@/hooks/useFetch";
import { AUTH_ACTION_TYPES } from "@/constants/actionTypes";
import customersRepository from "@/repository/customers-repository";
import {
  Customer,
  Login,
  Register,
  ResendVerification,
  UpdatePhone,
  UpdateProfile,
  VerificationBase,
} from "@/types/dtos/customers";
const { LOGOUT_SUCCESS, VERIFY_SUCCESS, UPDATE_USER_SUCCESS } =
  AUTH_ACTION_TYPES;
const CustomersActions = () => {
  const { handleApiResponse } = useFetch();

  const login = async (data: Login) => {
    return handleApiResponse({
      showSuccessToast: false,
      callback: () => customersRepository.login(data),
    });
  };
  const register = async (data: Register) => {
    return handleApiResponse({
      callback: () => customersRepository.register(data),
    });
  };
  const resendVerification = async (data: ResendVerification) => {
    return handleApiResponse({
      callback: () => customersRepository.resendVerification(data),
    });
  };
  const verifyRegistration = async (data: VerificationBase) => {
    return handleApiResponse({
      callback: () => customersRepository.verifyRegistration(data),
    });
  };

  const verifyLogin = async (data: VerificationBase) => {
    return handleApiResponse({
      callback: () => customersRepository.verifyLogin(data),
    });
  };

  const updatePhone = async (data: UpdatePhone) => {
    return handleApiResponse({
      callback: () => customersRepository.updatePhone(data),
    });
  };
  const verifyUpdatePhone = async (data: VerificationBase) => {
    return handleApiResponse({
      callback: () => customersRepository.verifyUpdatePhone(data),
    });
  };
  const updateProfile = async (data: UpdateProfile) => {
    return handleApiResponse({
      callback: () => customersRepository.updateProfile(data),
    });
  };

  const logout = () => {
    return async (dispatch: (action: any) => void) => {
      try {
        dispatch({
          type: LOGOUT_SUCCESS,
        });
      } catch (e) {
        console.log(e);
      }
    };
  };

  const onVerifySuccess = ({ data }: any) => {
    return async (dispatch: (action: any) => void) => {
      dispatch({
        type: VERIFY_SUCCESS,
        payload: { data },
      });
    };
  };

  const updateUserSuccess = (user: Customer) => {
    return async (dispatch: (action: any) => void) => {
      dispatch({ type: UPDATE_USER_SUCCESS, payload: { user } });
    };
  };
  return {
    login,
    logout,
    resendVerification,
    register,
    verifyLogin,
    verifyRegistration,
    updatePhone,
    verifyUpdatePhone,
    updateProfile,
    updateUserSuccess,
    onVerifySuccess,
  };
};

export default CustomersActions;
